import AssetFilter from "./AssetFilter";
import DragModal from "../../common/components/DragModal";
import { Box, DialogContent, Divider, Typography } from "@mui/material";
import { getTagsWithFilter } from "../../api/APIHelpers";
import { useContext } from "react";
import { LookupValueContext } from "../../common/contexts/LookupValueContext";
import { extractApiErrorMessage } from "../../common/helpers/ErrorUtils";
import { addLookupValueFieldsToTag } from "../helpers/Helpers";
import { CollisionMode } from "./SelectCollisionMode";

export default function EditTabSourceModal({
  open,
  onClose,
  setSourceFilter,
  sourceFilter,
  collisionMode,
  collisionPrompt,
  setLoading,
  appendTagsToGrid,
  setInfoMessages,
}) {
  const lookupValues = useContext(LookupValueContext);
  const handleAssetFilterActions = async (action) => {
    if (action.modalState === "closed") {
      onClose();
    }
    if (action.filter) {
      setSourceFilter(action.filter);
      if (collisionMode === CollisionMode.NoneSet) {
        collisionPrompt();
        return;
      }
      if (action.filter.length) {
        try {
          setLoading(true);
          let result = await getTagsWithFilter(action.filter);
          const tags = result.data.map((tag) => {
            return addLookupValueFieldsToTag(tag, lookupValues);
          });
          appendTagsToGrid(tags);
        } catch (error) {
          console.error("Failed to get tags with filter:", error);
          setInfoMessages({
            type: "snackbar",
            message: `Failed to get tags with filter: ${extractApiErrorMessage(error)}`,
            severity: "error",
            open: true,
          });
        } finally {
          setLoading(false);
        }
      }
    }
  };

  return (
    <DragModal
      open={open}
      title='editTagsSource'
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      titlecomponent={
        <Typography variant='h5' color='primary'>
          Filter
        </Typography>
      }>
      <Divider />
      <DialogContent>
        <Box sx={{ minWidth: 300 }}>
          <AssetFilter
            presetFilter={sourceFilter}
            assetFilterActions={handleAssetFilterActions}
          />
        </Box>
      </DialogContent>
    </DragModal>
  );
}
